/**
 * Lampenwerk24 – Live-Support-Widget v8 (14.08.2026)
 *
 * v8: Beim Oeffnen wird das Eingabefeld auf Touch-Geraeten NICHT mehr fokussiert. Der Fokus
 * hatte die Bildschirmtastatur mit aufgeklappt, die rund die Haelfte des Panels verdeckte —
 * vom Startbildschirm blieben zwei der vier Themen sichtbar, der Link ins Hilfe-Center lag
 * dahinter. Begruendung an der Stelle selbst (openPanel).
 *
 * Live-Support-Widget v7 (11.08.2026, Mobile + Wiederkehrer)
 *
 * Drei Aenderungen nach Max' iPhone-Screenshot vom 11.08.2026:
 * 1. Scroll-Sperre: solange das Panel auf dem Handy offen ist (<=480px, randloses Vollbild),
 *    scrollt die Seite dahinter nicht mehr mit (vorher lief der Shop unter dem Chat weiter).
 *    Umsetzung siehe scrollSperreSetzen() — bewusst NICHT die vorhandene lw-no-scroll-Klasse
 *    aus lw-mega-menu.css, Begruendung am CSS-Block in lw-live-support.css.
 * 2. Zeit-Trenner tragen ein Datum, sobald die Nachricht nicht von heute ist ("Gestern, 15:31" /
 *    "28. Juli, 15:31"). Ein Kunde, der nach drei Wochen wiederkommt, konnte mit "15:31" allein
 *    nichts anfangen.
 * 3. Eine gespeicherte Session verfaellt nach 14 Tagen ohne Nachricht (SESSION_RESET_MS): der
 *    Kunde startet dann automatisch mit einem leeren Chat, selbst wenn der alte Fall im Postfach
 *    versehentlich nie erledigt wurde. Die Frist ist bewusst dieselbe wie serverseitig: erledigte
 *    Faelle altern nach 14 Tagen Inaktivitaet aus dem Live-Store (supIngest in worker.js), chat-poll
 *    antwortet danach ohnehin 404. Neu ist die Abdeckung der OFFEN vergessenen Faelle — die altern
 *    serverseitig nie (pruneStaleChatSessions erledigt nur nie-eskalierte Chats nach 24h).
 *
 * v6 (27.07.2026, Runde 5 nach Feedback)
 *
 * Neu in v6 — die Schnellwahl ist jetzt ein festes Dock ueber dem Composer (10 statt 4 Optionen)
 * und wird per [hidden] getoggelt statt aus dem DOM entfernt. Dabei fielen drei Fehler auf, die
 * alle drei denselben Ursprung hatten (Reihenfolge der Schritte in openPanel/sendMessage):
 *   1. Die Begruessung wurde eingefuegt und drei Zeilen spaeter vom eigenen Wipe wieder geloescht.
 *   2. Eine gespeicherte Session genuegte, damit die Chips beim Oeffnen verschwanden — auch im
 *      voellig leeren Chat, dauerhaft, fuer jeden wiederkehrenden Besucher.
 *   3. Ein abgelehnter fetch riss openPanel nach dem Leeren, aber vor dem Neuaufbau ab: Panel leer,
 *      ohne Poll-Timer. api() faengt Netzwerkfehler jetzt ab (status 0).
 *
 * v5 (20.07.2026, Redesign Runde 4 nach Feedback)
 * Ersetzt das Commslayer-Web-Widget. Spricht direkt mit dem bestehenden Worker
 * (production-dashboard/worker/worker.js: /api/chat-start, /api/chat-send, /api/chat-poll).
 *
 * Kein Session-Handling über Cookies/Server-Auth — ein zufälliger Pro-Session-Token lebt nur in
 * diesem Browser (localStorage) und wird bei jedem Call mitgeschickt, siehe chat_token_hash im
 * Worker. Erste UND jede weitere autopilot-fähige Nachricht kommt SYNCHRON in der send-Response
 * zurück (kein Poll-Delay); der Poll-Loop (nur bei offenem Panel) holt Max' Antworten + spätere
 * Autopilot-Antworten nach.
 *
 * Neu in v5 (Feedback: KI soll nicht als solche auffallen, kein dauerhafter "Mensch"-Button):
 * - Keine KI/Team-Kennzeichnung mehr im Chat selbst — nahtloses Gespräch aus Kundensicht.
 * - "Lieber mit dem Team sprechen"-Vorschlag erscheint EINMALIG als Chat-Nachricht, erst NACHDEM
 *   die KI zweimal geantwortet hat (aiReplyCount) — kein permanent sichtbarer Button.
 * - Eskalation (ob durch KI-Ablehnung, Vorschlag-Klick oder harte Fälle) zeigt inline ein
 *   E-Mail-Eingabefeld (Template #lw24-support-email-tpl) statt nur einer Text-Floskel — das Team
 *   antwortet meist erst nach 1 bis 4 Std., der Kunde braucht einen Weg, erreichbar zu bleiben.
 */
(function () {
  "use strict";

  var API = "https://lampenwerk24-production-sync.soft-sun-fb60.workers.dev";
  var LS_SESSION = "l24_support_session";
  var LS_TOKEN = "l24_support_token";
  var LS_LAST = "l24_support_last";
  var LS_SEEN = "l24_support_seen";       // Server-Stand (total), bis zu dem der Kunde alles gesehen hat
  var LS_VORSCHAU_ZU = "l24_support_vz";  // Kennung der Antwort, deren Vorschau weggeklickt wurde
  var LS_UNGELESEN = "l24_support_ungelesen";  // letzte bekannte rote Zahl samt Vorschau, fuer den Seitenwechsel
  // Muss VOR sessionVerfallPruefen() stehen (laeuft beim Laden und kann clearSession rufen).
  var hg = { timer: null, laeuft: false, aus: false };
  var HG_POLL_MS = 30000;                 // Takt bei GESCHLOSSENEM Chat (rote Zahl, Vorschau)
  var TEAM_FALLBACK = "Lampenwerk24 Team";
  var POLL_MS = 3000;
  var TIME_GAP_MS = 5 * 60 * 1000; // ab dieser Lücke zwischen zwei Nachrichten: neuer Zeit-Trenner
  var SUGGEST_AFTER = 2; // KI-Antworten, bevor der "Team fragen"-Vorschlag einmalig erscheint
  // Nach dieser Zeit ohne Nachricht verfaellt die gespeicherte Session und der Kunde startet
  // frisch. 14 Tage = dieselbe Frist, nach der erledigte Faelle serverseitig aus dem Live-Store
  // altern (supIngest, worker.js) — kuerzer waere inkonsistent, laenger schuetzt niemanden: die
  // Frist existiert fuer Faelle, die im Postfach versehentlich offen geblieben sind und sonst
  // beim Kunden ewig als angefangenes Gespraech kleben wuerden.
  var SESSION_RESET_MS = 14 * 24 * 60 * 60 * 1000;
  // Unterhalb dieser Breite ist das Panel randloses Vollbild (siehe Media-Query im CSS) — nur
  // dann wird die Seite dahinter am Scrollen gehindert. Auf dem Desktop bleibt sie scrollbar,
  // das Panel ist dort ein Popup neben dem Inhalt (Intercom/Zendesk verhalten sich genauso).
  var MOBILE_VOLLBILD_MQ = "(max-width: 480px)";

  var state = {
    session: null,
    token: null,
    knownCount: 0,
    pollTimer: null,
    open: false,
    sending: false,
    lastMsgTime: null,
    aiReplyCount: 0,
    suggestShown: false,
    emailFormShown: false,
    dringendShown: false,
    geschlossen: false,
    abschlussShown: false,
    letzteAktion: null,   // Zeitstempel der letzten Kundenaktion, siehe istPraesent
    stempelZeit: null,    // wann zuletzt praesent GESPEICHERT wurde, siehe stempelFaellig
    stempelWert: null,    // und mit welchem Wert - ein Wechsel loest sofort einen neuen aus
    pollTakt: null,
    titelOriginal: null,
    titelTimer: null,
    ungelesen: 0,
    pushGefragt: false    // die Berechtigungsabfrage kommt hoechstens einmal je Sitzung
  };

  try {
    state.session = localStorage.getItem(LS_SESSION) || null;
    state.token = localStorage.getItem(LS_TOKEN) || null;
  } catch (e) {}
  sessionVerfallPruefen();

  function el(id) { return document.getElementById(id); }

  // Jede echte Chat-Aktivitaet (Nachricht gezeichnet oder gesendet) schiebt den Verfall hinaus.
  // Bewusst NICHT nur das Absenden: auch eine spaete Antwort von Max zaehlt, sonst verfiele ein
  // Fall, waehrend das Team noch daran arbeitet.
  function touchAktivitaet() {
    try { localStorage.setItem(LS_LAST, String(Date.now())); } catch (e) {}
  }

  /* Laeuft beim Laden der Seite und bei jedem Oeffnen des Panels — nicht nur einmal: ein Tab kann
     wochenlang offen liegen, das Laden allein reicht als Pruefzeitpunkt nicht.
     Sessions aus der Zeit VOR diesem Update haben noch keinen Zeitstempel; sie bekommen jetzt
     einen und verfallen von da an normal — sie sofort zu verwerfen wuerde laufende Gespraeche
     von Bestandskunden kappen. */
  function sessionVerfallPruefen() {
    if (!state.session) return;
    var last = 0;
    try { last = parseInt(localStorage.getItem(LS_LAST), 10) || 0; } catch (e) {}
    if (!last) { touchAktivitaet(); return; }
    if (Date.now() - last <= SESSION_RESET_MS) return;
    clearSession();
    /* Auch das Fenster selbst aufraeumen, falls dort noch ein frueher gerenderter Verlauf steht —
       passiert nur, wenn derselbe Tab laenger offen lag als die Frist. Beim normalen Seitenladen
       ist die Box leer und die querySelectorAll-Liste schlicht ohne Treffer. Selektorenliste und
       Flag-Reset entsprechen dem Wipe in openPanel bzw. dem "Neue Frage stellen"-Neustart. */
    var box = el("lw24-support-messages");
    if (box) Array.prototype.slice.call(box.querySelectorAll(".lw24-support-msg, .lw24-support-teamgrp, .lw24-support-time, .lw24-support-suggest, .lw24-support-ende, .lw24-support-abschluss, .lw24-support-dringend")).forEach(function (n) { n.remove(); });
    var f = el("lw24-support-form");
    if (f) f.hidden = false;
    state.geschlossen = false; state.abschlussShown = false;
    state.aiReplyCount = 0; state.suggestShown = false;
    state.emailFormShown = false; state.dringendShown = false;
    statusAus();
    state.lastMsgTime = null;
    gezeichnet = {}; offeneEigene = {};
  }

  /* Scroll-Sperre fuer den Hintergrund, solange das Panel auf dem Handy offen ist.
     Idempotent und von drei Stellen aufgerufen (oeffnen, schliessen, Breiten-Wechsel z.B. durch
     Drehen des Geraets) — die Funktion prueft selbst, ob Soll und Ist auseinanderliegen.
     position:fixed setzt die Seite optisch auf Position 0 zurueck, deshalb wird die Scrollposition
     vorher gemerkt, per top-Versatz gehalten und beim Entsperren wiederhergestellt. */
  var scrollSperrePos = 0;
  function scrollSperreSetzen() {
    var body = document.body;
    if (!body) return;
    var soll = state.open && window.matchMedia(MOBILE_VOLLBILD_MQ).matches;
    var ist = body.classList.contains("lw24-support-scroll-halt");
    if (soll === ist) return;
    /* ⚠️ ZWEI ZEILEN, NICHT EINE (P-85, 09.10.2026). Max vom iPhone: das X oben
       rechts reagierte erst nach rund 5 Sekunden und 10 Tipps, danach stand die
       Preiszeile woanders.

       1. <html> ist das scrollingElement und stand auf overflow visible. Der
          feste Body ragt daraus hervor, und auf iOS wird dieser Ueberhang
          wieder scrollbar: das Dokument rutscht hinter dem Panel weiter, und
          solange es rutscht, nimmt Safari jeden Tipp als "Scrollen anhalten".
          Derselbe Fall wie beim Filter-Schubfach (CLAUDE.md, "Der Body allein
          reicht nicht, <html> muss mit"); Warenkorb und Filter sperren beide.
       2. lw-v6-foundation.css setzt html{scroll-behavior:smooth}. Damit war das
          scrollTo beim Schliessen eine Animation von Position 0 zurueck an die
          alte Stelle (gemessen 0 bis 698px in rund 400ms): die Seite fuhr
          sichtbar von oben herunter, und waehrenddessen gingen Tipps ins Leere.
          Zurueck geht es jetzt in einem Schritt. */
    var html = document.documentElement;
    if (soll) {
      scrollSperrePos = window.pageYOffset || html.scrollTop || 0;
      body.style.top = -scrollSperrePos + "px";
      html.classList.add("lw24-support-scroll-halt");
      body.classList.add("lw24-support-scroll-halt");
    } else {
      html.classList.remove("lw24-support-scroll-halt");
      body.classList.remove("lw24-support-scroll-halt");
      body.style.top = "";
      var sb = html.style.scrollBehavior;
      html.style.scrollBehavior = "auto";
      window.scrollTo(0, scrollSperrePos);
      html.style.scrollBehavior = sb;
    }
  }


  /* Uhrzeit allein genuegt nur fuer heute. Der Verlauf wird beim Wiederoeffnen komplett vom
     Server neu aufgebaut — ein Kunde, der nach drei Wochen wiederkommt, las bisher "15:31" und
     konnte nicht wissen, OB das heute war (Max, 11.08.2026: "ich muss wissen wann das war").
     Deshalb: heute nur Uhrzeit (wie bisher), gestern "Gestern, 15:31", aelter mit Datum und bei
     fremdem Jahr zusaetzlich mit Jahreszahl. */
  function fmtTime(iso) {
    var d = iso ? new Date(iso) : new Date();
    if (isNaN(d)) return "";
    var s = (Date.now() - d.getTime()) / 1000;
    if (s < 60) return "Gerade eben";
    var uhr = d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
    var heute = new Date();
    if (d.toDateString() === heute.toDateString()) return uhr;
    var gestern = new Date(heute.getFullYear(), heute.getMonth(), heute.getDate() - 1);
    if (d.toDateString() === gestern.toDateString()) return "Gestern, " + uhr;
    var fmt = { day: "numeric", month: "long" };
    if (d.getFullYear() !== heute.getFullYear()) fmt.year = "numeric";
    return d.toLocaleDateString("de-DE", fmt) + ", " + uhr;
  }

  function scrollToEnd() {
    var box = el("lw24-support-messages");
    if (box) box.scrollTop = box.scrollHeight;
  }

  /* ── Das Eingabefeld waechst mit, aber nur so lange es muss ────────────────────
     Max am 14.08.2026, mit drei Screenshots: nach EINEM getippten Wort stand rechts
     im Feld schon eine Bildlaufleiste, und ab drei Zeilen hoerte das Feld auf zu
     wachsen.

     ⚠️ DIE LEISTE KAM VOM RECHENFEHLER, NICHT VON ZU VIEL TEXT. Die alte Zeile
     lautete height = min(scrollHeight, 84). scrollHeight ist Inhalt PLUS Polster,
     aber OHNE Rahmen. Steht das Feld auf box-sizing:border-box - und das tut es,
     weil Dawn das global setzt - dann muss der Rahmen in der Hoehe mit drin sein.
     Es fehlten also zwei Pixel, der Inhalt passte um genau diese zwei Pixel nicht
     mehr hinein, und der Browser blendete eine Leiste ein. Bei einem Wort.

     Deshalb wird der Rahmen jetzt aus dem berechneten Stil dazugerechnet statt
     geraten, und beide Box-Modelle sind abgedeckt: bei content-box zaehlt height
     ohne Polster, dann muss es abgezogen werden.

     Gemessen wird immer OHNE Leiste (overflow-y:hidden), sonst misst man die
     Leiste mit und das Feld schaukelt sich Zeile fuer Zeile auf. Sichtbar wird sie
     erst, wenn die Obergrenze wirklich erreicht ist - dort ist sie richtig, denn
     dann gibt es tatsaechlich etwas zu scrollen.

     148px sind rund sechs Zeilen statt der bisherigen drei. Mehr nicht: der
     Composer sitzt im selben Panel wie der Verlauf, und was er an Hoehe nimmt,
     fehlt dem Gespraech darueber. */
  var COMPOSER_MAX = 148;

  function composerAnpassen(input) {
    if (!input) return;
    input.style.height = "auto";
    input.style.overflowY = "hidden";

    var stil = window.getComputedStyle(input);
    var noetig = input.scrollHeight;
    if (stil.boxSizing === "border-box") {
      noetig += (parseFloat(stil.borderTopWidth) || 0) + (parseFloat(stil.borderBottomWidth) || 0);
    } else {
      noetig -= (parseFloat(stil.paddingTop) || 0) + (parseFloat(stil.paddingBottom) || 0);
    }

    if (noetig > COMPOSER_MAX) {
      input.style.height = COMPOSER_MAX + "px";
      input.style.overflowY = "auto";
    } else {
      input.style.height = noetig + "px";
    }
  }

  function maybeAddTimeDivider(iso) {
    var t = iso ? new Date(iso).getTime() : Date.now();
    if (state.lastMsgTime !== null && (t - state.lastMsgTime) < TIME_GAP_MS) return;
    var box = el("lw24-support-messages");
    if (!box) return;
    var d = document.createElement("div");
    d.className = "lw24-support-time";
    d.textContent = fmtTime(iso);
    box.appendChild(d);
  }

  // Rendert eine echte, serverseitig gespeicherte Nachricht (Kunde/Team/KI) — BEWUSST OHNE
  // KI/Team-Kennzeichnung im UI (Feedback: nahtloses Gespräch, der Kunde soll nicht bei jeder
  // Nachricht "das ist ein Bot" denken). Der Worker verfolgt "quelle" weiterhin intern/fürs
  // Postfach (siehe postfach.html) — hier zählt nur, wie oft die KI schon geantwortet hat, um
  // den einmaligen Team-Vorschlag auszulösen.
  /* Team-Antwort = Nachricht von uns mit quelle "max" (so tragen sie die Team-Antworten im Worker,
     supReply) ODER mit senderName. autopilot und system sind NIE Team: weder Name noch rote Zahl noch
     Vorschau, auch nicht, wenn ein senderName mitkaeme. Eine unbekannte quelle ohne senderName ist
     ebenfalls kein Team (lieber keine Zahl als eine falsche). */
  function istTeamAntwort(m) {
    if (!m || m.von !== "wir") return false;
    if (m.quelle === "autopilot" || m.quelle === "system") return false;
    return m.quelle === "max" || !!(typeof m.senderName === "string" && m.senderName.trim());
  }
  function teamName(m) {
    var n = m && typeof m.senderName === "string" ? m.senderName.trim() : "";
    return n || "";
  }
  function teamAnzeige(m) {
    var n = teamName(m);
    return n ? n + " vom Team" : TEAM_FALLBACK;
  }
  function teamBuchstabe(m) {
    var n = teamName(m) || TEAM_FALLBACK;
    return (Array.from(n)[0] || "L").toUpperCase();
  }
  var gezeichnet = {};   // msg_id -> true, damit dieselbe Nachricht nie zweimal im Fenster steht
  /* Die eigene Nachricht wird sofort beim Absenden gezeichnet, damit das Fenster nicht traege
     wirkt. Sie hat zu diesem Zeitpunkt aber noch keine Kennung vom Server. Kommt sie beim naechsten
     Abgleich mit Kennung zurueck, wuerde sie ein zweites Mal erscheinen. Deshalb wird der
     Platzhalter hier vermerkt und die Server-Fassung stillschweigend uebernommen. */
  var offeneEigene = {};
  function addMsg(m) {
    if (m && m.msg_id) {
      if (gezeichnet[m.msg_id]) return;
      if (m.von === "kunde" && offeneEigene[m.text]) { gezeichnet[m.msg_id] = true; delete offeneEigene[m.text]; return; }
      gezeichnet[m.msg_id] = true;
    } else if (m && m.von === "kunde") {
      offeneEigene[m.text] = true;
    }
    var box = el("lw24-support-messages");
    if (!box) return;
    touchAktivitaet();
    maybeAddTimeDivider(m.zeit);
    state.lastMsgTime = m.zeit ? new Date(m.zeit).getTime() : Date.now();

    var kind = m.von === "wir" ? (m.quelle === "system" ? "system" : "wir") : "kunde";
    var d = document.createElement("div");
    d.className = "lw24-support-msg " + kind;
    if (istTeamAntwort(m)) {
      /* Team-Antwort als Einheit aus Kreis, Name und Blase (Board v4, P-69): Kreis 28px oben buendig
         mit der Blase, 6px Abstand, Spitze zum Kreis, Name als erste Zeile auf Kreismitte. Eine
         Folgenachricht desselben Absenders OHNE dazwischenliegendes Element (Zeit-Trenner,
         Kundenblase, Hinweis) haengt als Blase 4px darunter in dieselbe Gruppe: kein neuer Kreis,
         kein neuer Name. */
      var anzeige = teamAnzeige(m);
      var letzte = box.lastElementChild;
      if (letzte && letzte.classList.contains("lw24-support-teamgrp") && letzte.getAttribute("data-von") === anzeige) {
        d.className = "lw24-support-tblase";
        d.appendChild(document.createTextNode(m.text || ""));
        letzte.appendChild(d);
      } else {
        var grp = document.createElement("div");
        grp.className = "lw24-support-teamgrp";
        grp.setAttribute("data-von", anzeige);
        var ava = document.createElement("span");
        ava.className = "lw24-support-ava";
        ava.setAttribute("aria-hidden", "true");
        ava.textContent = teamBuchstabe(m);
        var von = document.createElement("span");
        von.className = "lw24-support-von";
        von.textContent = anzeige;
        d.className = "lw24-support-tblase lw24-support-tblase--erste";
        d.appendChild(von);
        d.appendChild(document.createTextNode(m.text || ""));
        grp.appendChild(ava);
        grp.appendChild(d);
        box.appendChild(grp);
      }
    } else {
      d.appendChild(document.createTextNode(m.text || ""));
      box.appendChild(d);
    }
    scrollToEnd();

    if (m.von === "wir" && m.quelle === "autopilot") {
      state.aiReplyCount++;
      if (state.aiReplyCount === SUGGEST_AFTER && !state.suggestShown) maybeShowSuggestion();
    }
  }

  // Client-seitige Hinweise ohne Server-Gegenstück (Begrüßung, Fehler, Rate-Limit) — immer als
  // neutrale System-Notiz, nie im knownCount mitgezählt.
  function addNote(text) {
    var box = el("lw24-support-messages");
    if (!box) return;
    var d = document.createElement("div");
    d.className = "lw24-support-msg system";
    d.textContent = text;
    box.appendChild(d);
    scrollToEnd();
  }

  // Einmaliger, dezenter Vorschlag im Nachrichtenfluss selbst (kein Dauer-Button) — erscheint erst
  // nachdem die KI SUGGEST_AFTER-mal geantwortet hat, falls der Kunde bis dahin noch nicht
  // eskaliert wurde.
  function maybeShowSuggestion() {
    if (state.suggestShown) return;
    state.suggestShown = true;
    var box = el("lw24-support-messages");
    if (!box) return;
    var wrap = document.createElement("div");
    wrap.className = "lw24-support-suggest";
    var span = document.createElement("span");
    span.textContent = "Nicht das Richtige dabei?";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = "Team fragen";
    btn.addEventListener("click", function () {
      wrap.remove();
      sendMessage("Ich möchte gerne mit dem Team sprechen.", true);
    });
    wrap.appendChild(span); wrap.appendChild(btn);
    box.appendChild(wrap);
    scrollToEnd();
  }

  /* Zwei Wege nach einem erledigten Anliegen (Fall #11573, 28.07.2026).
     Der Chat schliesst NICHT von selbst: Nur der Kunde weiss, ob er wirklich fertig ist. Wer noch
     etwas hat, tippt ohnehin einfach weiter — der Block verschwindet dann von allein. */
  function showAbschluss() {
    if (state.abschlussShown || state.geschlossen) return;
    state.abschlussShown = true;
    var tpl = el("lw24-support-abschluss-tpl");
    var box = el("lw24-support-messages");
    if (!tpl || !box) return;
    var wrap = tpl.content.cloneNode(true).querySelector(".lw24-support-abschluss");
    wrap.addEventListener("click", function (e) {
      var b = e.target.closest("[data-abschluss]");
      if (!b) return;
      wrap.remove();
      state.abschlussShown = false;
      if (b.getAttribute("data-abschluss") === "beenden") {
        sendMessage("Das war's, danke.", false, "beenden");
      } else {
        /* ⚠️ 14.08.2026, von Max gemeldet: "kunde klickt pill an, aber niemand weiss, dass
           diese pill geklickt wurde". Hier stand vorher nur ein focus() mit dem Kommentar
           "Kein Netzaufruf noetig: Der Kunde will einfach weiterschreiben."

           Das war aus Kundensicht ein Klick ins Leere: die Pille verschwand, im Verlauf
           stand nichts, im Postfach kam nichts an, und eine Antwort gab es auch nicht. Wer
           gerade "Ich hab noch eine Frage" gesagt hat, erwartet mindestens ein "Gerne, worum
           geht es?" - und das Team muss sehen, dass das Gespraech weitergeht, sonst gilt der
           Fall dort als erledigt.

           Jetzt geht der Klick denselben Weg wie die andere Pille: als echte Nachricht mit
           eigenem intent. Der Fokus bleibt, weil der Kunde hier ausdruecklich schreiben
           will - anders als beim Oeffnen des Panels, wo er genau deshalb entfernt wurde. */
        sendMessage("Ich hab noch eine Frage.", false, "weiter");
        var f = el("lw24-support-input");
        if (f) f.focus();
      }
    });
    box.appendChild(wrap);
    scrollToEnd();
  }

  // Dringend-Weg: erscheint nur, wenn der Worker ihn freigibt (Antwortfeld dringend_moeglich).
  // Zwei Schritte statt einem Formular: erst Anlass anklicken, dann Datum. Ein einzelner Klick
  // reicht so schon fuer die Haelfte der Angabe, und das Datumsfeld erscheint erst, wenn es
  // ueberhaupt relevant ist.
  function showDringend() {
    if (state.dringendShown) return;
    state.dringendShown = true;
    var tpl = el("lw24-support-dringend-tpl");
    var box = el("lw24-support-messages");
    if (!tpl || !box) return;
    var frag = tpl.content.cloneNode(true);
    var wrap = frag.querySelector(".lw24-support-dringend");
    var form = frag.querySelector(".lw24-support-dringend-form");
    var gewaehlt = null;
    wrap.addEventListener("click", function (e) {
      var b = e.target.closest("[data-anlass]");
      if (!b) return;
      gewaehlt = b.getAttribute("data-anlass");
      Array.prototype.slice.call(wrap.querySelectorAll("[data-anlass]")).forEach(function (x) {
        x.setAttribute("aria-pressed", x === b ? "true" : "false");
      });
      form.hidden = false;
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var datum = form.querySelector(".lw24-support-dringend-datum").value || "";
      form.querySelector(".lw24-support-dringend-send").disabled = true;
      wrap.remove();
      sendMessage("Ich brauche die Lampe bis zum " + datum + " (" + gewaehlt + ").", false, "dringend", { anlass: gewaehlt, termin: datum });
    });
    box.appendChild(wrap);
    scrollToEnd();
  }

  // Inline E-Mail-Erfassung bei Eskalation — Template statt Hand-HTML in JS, siehe .liquid.
  //
  // ⚠️ 14.08.2026, von Max gemeldet: ein Kunde hatte sich vertippt, schrieb "ich habe eine
  // falsch mail adresse angegeben" - und bekam zweimal dieselbe Bestaetigung zurueck. Es gab
  // schlicht keinen Weg zurueck: submitEmail entfernte das Formular, state.emailFormShown
  // blieb auf true, und showEmailCapture stieg danach in Zeile eins wieder aus. Die falsche
  // Adresse war damit endgueltig.
  //
  // Jetzt steht unter der Bestaetigung die eingetragene Adresse und daneben ein Knopf, der
  // das Formular erneut oeffnet - vorbelegt, damit man den Tippfehler sehen und korrigieren
  // kann, statt alles neu zu tippen. Beliebig oft wiederholbar.
  //
  // Der Freitext-Weg ("ich habe mich vertippt") ist seit dem 14.08.2026 ebenfalls offen: der
  // Worker erkennt eine Korrektur, wenn Korrekturwort UND neue Adresse in derselben Nachricht
  // stehen, uebernimmt sie und bestaetigt sie namentlich (chatSend, adresseAntwort). Der Knopf
  // hier bleibt trotzdem der zuverlaessigere Weg - er stellt "Korrektur meiner E-Mail-Adresse:"
  // voran und trifft damit immer.
  /* ⚠️ 07.10.2026 (P-69, Punkt 4, Statusleiste B): Hinweis und E-Mail-Feld stehen nicht mehr UNTER
     dem Verlauf, sondern als feste Leiste OBEN im Panel (#lw24-support-status). Vorher rutschte das
     Feld mit jeder neuen Nachricht nach oben aus dem Bild und wurde bei jeder Antwort neu
     angehaengt. Die Korrektur-Logik (vorbelegtes Feld, "Korrektur meiner E-Mail-Adresse:") ist
     unveraendert, nur der Ort ist ein anderer. */
  function statusEl() { return el("lw24-support-status"); }
  function statusAus() {
    var st = statusEl();
    if (st) st.hidden = true;
    state.emailFormShown = false;
  }
  function statusZeigen(modus, vorbelegt, email) {
    var st = statusEl();
    if (!st) return null;
    var form = st.querySelector(".lw24-support-email-form");
    var ok = st.querySelector(".lw24-support-status-ok");
    var z2 = st.querySelector(".lw24-support-status-z2");
    var input = st.querySelector(".lw24-support-email-input");
    st.hidden = false;
    if (modus === "ok") {
      form.hidden = true; z2.hidden = true; ok.hidden = false;
      ok.querySelector(".lw24-support-status-ok-t").textContent = "Danke, wir melden uns an " + email + ".";
    } else {
      form.hidden = false; z2.hidden = false; ok.hidden = true;
      if (vorbelegt) input.value = vorbelegt;
      st.querySelector(".lw24-support-email-send").disabled = false;
    }
    return st;
  }

  function showEmailCapture(vorbelegt) {
    var st = statusEl();
    // Steht die Leiste schon (Formular ODER Danke-Zeile), kommt nichts dazu: jede Poll-Antwort
    // mit escalated=true ruft das hier auf, und die Danke-Zeile darf dabei nicht ueberschrieben werden.
    if (!st || state.emailFormShown || !st.hidden) return;
    state.emailFormShown = true;
    statusZeigen("form", vorbelegt);
  }

  async function submitEmail(email, istKorrektur) {
    var okSession = await ensureSession();
    if (!okSession) return;
    await api("/api/chat-send", {
      method: "POST", headers: { "Content-Type": "application/json" },
      // Bei einer Korrektur steht das auch so in der Nachricht: im Postfach sieht man sonst
      // zwei Adressen untereinander und weiss nicht, welche gilt.
      body: JSON.stringify({
        session_id: state.session, token: state.token,
        message: (istKorrektur ? "Korrektur meiner E-Mail-Adresse: " : "Meine E-Mail-Adresse: ") + email,
        email: email
      })
    });
    state.emailFormShown = false;
    statusZeigen("ok", null, email);
    // Genau JETZT ist der Moment fuer die Push-Frage - siehe showPushAngebot.
    showPushAngebot();
    scrollToEnd();
  }

  function statusVerdrahten() {
    var st = statusEl();
    if (!st || st.getAttribute("data-bereit")) return;
    st.setAttribute("data-bereit", "1");
    var form = st.querySelector(".lw24-support-email-form");
    var input = st.querySelector(".lw24-support-email-input");
    var aendern = st.querySelector(".lw24-support-email-aendern");
    var istKorrektur = false;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var neu = (input.value || "").trim();
      if (!neu) return;
      st.querySelector(".lw24-support-email-send").disabled = true;
      submitEmail(neu, istKorrektur);
    });
    aendern.addEventListener("click", function () {
      var alt = (st.querySelector(".lw24-support-status-ok-t").textContent.match(/an (.+)\.$/) || [])[1] || "";
      istKorrektur = true;
      state.emailFormShown = true;
      statusZeigen("form", alt);
      try { input.focus(); input.setSelectionRange(0, input.value.length); } catch (e) {}
    });
  }

  /* ══════════════════════════════════════════════════════════════════════════
     PUSH-MELDUNG AUFS HANDY (14.08.2026)

     Max: "kann man auch eine handy benachrichtigung senden? also nicht so, dass
     jeder benutzer auf unserer seite erstmal bestaetigen muss, dass man
     benachrichtungen empfangen kann - das wuerde abschrecken, aber ab einem
     gewissen punkt im oder vor dem livechat klingt das nicht verkehrt, wenn man
     da so eine abfrage / berechtigung sich einholt vom kunden um per pushmeldung
     den warmen kunden wieder in den chat zu holen!"

     DER ZEITPUNKT IST DER GANZE PUNKT. Gefragt wird erst, wenn der Kunde gerade
     seine E-Mail-Adresse hinterlassen hat - also nach der Eskalation, wenn er
     weiss, dass er auf eine Antwort wartet, und schon einmal gesagt hat, dass
     er erreichbar sein will. Nie beim Laden der Seite, nie beim Oeffnen des
     Chats, nie bei einer Frage, die der Automat sofort beantwortet.

     ZWEI STUFEN, UND DAS IST KEIN SCHMUCK. Zuerst ein Knopf IN UNSEREM Fenster,
     erst nach dessen Klick die Abfrage des Browsers. Der Grund ist technisch:
     ein "Nein" im Browser-Dialog ist in Chrome und Firefox endgueltig - danach
     kann die Seite nie wieder fragen, und der Kunde muesste die Einstellung von
     Hand suchen. Ein "Nein" an unserem eigenen Knopf kostet dagegen nichts.
     Deshalb wird der Browser-Dialog nur jemandem gezeigt, der vorher aktiv
     zugestimmt hat.

     WAS DAS AUF DEM IPHONE NICHT KANN, damit es niemand falsch erwartet: Safari
     laesst Web-Push nur zu, wenn die Seite zum Startbildschirm hinzugefuegt
     wurde. Das ist Apples Einschraenkung und betrifft die Mehrheit der Besucher.
     Deshalb steht die Push-Frage NEBEN der E-Mail-Bestaetigung und nicht statt
     ihrer: die Mail ist der Weg, der ueberall funktioniert.

     Die Worker-Seite gibt es schon seit dem 09.08.2026 (VAPID-Paar,
     /api/chat-push-key, /api/chat-push-abo, chatPushAnKunde bei jeder Antwort
     von Max). Sie wurde nur nie angerufen - im Theme fehlten der Service Worker
     und diese Anmeldung. ══════════════════════════════════════════════════════ */

  function pushMoeglich() {
    try {
      return !!(window.isSecureContext && "serviceWorker" in navigator &&
                "PushManager" in window && "Notification" in window);
    } catch (e) { return false; }
  }

  /* Die Adresse des Service Workers steht am <script>-Tag, weil nur Liquid sie
     kennt (asset_url haengt an der Theme-Fassung). Kommt sie von einer anderen
     Herkunft als die Seite, faellt Push ersatzlos aus: einen fremden Service
     Worker kann kein Browser registrieren. Das ist kein Fehler, sondern der
     Grund, warum hier ueberall still ausgestiegen wird - der Kunde soll nie
     einen Knopf sehen, der dann nicht funktioniert. */
  function swAdresse() {
    try {
      var tag = document.querySelector('script[data-sw]');
      var roh = tag && tag.getAttribute("data-sw");
      if (!roh) return null;
      var u = new URL(roh, location.href);
      return u.origin === location.origin ? u.href : null;
    } catch (e) { return null; }
  }

  // VAPID-Schluessel kommen als base64url und muessen als Bytefolge uebergeben werden.
  function b64uZuBytes(b64u) {
    var b64 = (b64u + "=".repeat((4 - b64u.length % 4) % 4)).replace(/-/g, "+").replace(/_/g, "/");
    var roh = atob(b64);
    var out = new Uint8Array(roh.length);
    for (var i = 0; i < roh.length; i++) out[i] = roh.charCodeAt(i);
    return out;
  }

  async function pushAnmelden() {
    var adresse = swAdresse();
    if (!adresse || !state.session) return false;
    var reg = await navigator.serviceWorker.register(adresse);
    // Ohne diese Zeile kann subscribe() auf eine noch installierende
    // Registrierung treffen und wirft "no active Service Worker".
    await navigator.serviceWorker.ready;

    var abo = await reg.pushManager.getSubscription();
    if (!abo) {
      var s = await api("/api/chat-push-key");
      if (!s.body || !s.body.ok || !s.body.key) return false;
      abo = await reg.pushManager.subscribe({
        // false ist nicht erlaubt: jede Meldung muss sichtbar sein. Genau so
        // soll es auch sein - ein stiller Push waere ein Tracker.
        userVisibleOnly: true,
        applicationServerKey: b64uZuBytes(s.body.key)
      });
    }
    var j = abo.toJSON();
    var r = await api("/api/chat-push-abo", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        conversation_id: "chat-" + state.session,
        // Das Token ist Pflicht (seit 14.08.2026): die Meldung traegt den
        // Antworttext, also Bestelldetails. Ohne Token koennte eine geratene
        // Sitzungs-ID die Anmeldung des Kunden ersetzen.
        token: state.token,
        endpoint: j.endpoint,
        keys: j.keys
      })
    });
    return !!(r.body && r.body.ok);
  }

  function showPushAngebot() {
    if (state.pushGefragt || !pushMoeglich() || !swAdresse()) return;
    var box = el("lw24-support-messages");
    if (!box) return;
    // Schon abgelehnt: nicht noch einmal anbieten. Der Browser wuerde den
    // Dialog ohnehin nicht mehr zeigen, und ein Knopf ohne Wirkung ist schlimmer
    // als keiner.
    if (Notification.permission === "denied") return;
    state.pushGefragt = true;

    // Bereits erlaubt (z.B. aus einem frueheren Gespraech): still anmelden,
    // ohne zu fragen. Der Kunde hat schon ja gesagt.
    if (Notification.permission === "granted") {
      pushAnmelden().catch(function () {});
      return;
    }

    var wrap = document.createElement("div");
    wrap.className = "lw24-support-msg system lw24-support-push";
    var text = document.createElement("span");
    text.textContent = "Sollen wir dir zusätzlich direkt hier Bescheid geben, sobald die Antwort da ist?";
    var knopf = document.createElement("button");
    knopf.type = "button";
    knopf.className = "lw24-support-push-ja";
    knopf.textContent = "Ja, benachrichtigen";
    knopf.addEventListener("click", async function () {
      knopf.disabled = true;
      var erlaubt = false;
      try { erlaubt = (await Notification.requestPermission()) === "granted"; } catch (e) {}
      var fertig = false;
      if (erlaubt) { try { fertig = await pushAnmelden(); } catch (e) { fertig = false; } }
      /* Drei Ausgaenge, drei verschiedene Saetze. Ein einziges "hat nicht
         geklappt" waere hier besonders aergerlich: beim iPhone liegt es NICHT
         am Kunden, und er kann es sogar beheben. */
      wrap.innerHTML = "";
      var m = document.createElement("span");
      if (fertig) m.textContent = "Alles klar, du bekommst eine Meldung, sobald wir antworten.";
      else if (!erlaubt) m.textContent = "Kein Problem, dann kommt die Antwort per E-Mail.";
      else m.textContent = "Meldungen gehen auf diesem Gerät leider nicht. Auf dem iPhone klappt es nur, wenn du die Seite zum Home-Bildschirm hinzufügst. Die Antwort kommt aber auf jeden Fall per E-Mail.";
      wrap.appendChild(m);
      scrollToEnd();
    });
    wrap.appendChild(text);
    wrap.appendChild(knopf);
    box.appendChild(wrap);
  }

  // Max erledigt den Fall im Postfach — dann soll das Gespraech auch beim Kunden zugehen, statt
  // dass er in einen abgeschlossenen Fall weiterschreibt und sich wundert, warum nichts kommt.
  // Der Weg zurueck bleibt offen: ein Klick startet ein frisches Gespraech.
  function chatGeschlossen() {
    if (state.geschlossen) return;
    state.geschlossen = true;
    statusAus();
    var form = el("lw24-support-form");
    if (form) form.hidden = true;
    setQuickVisible(false);
    var box = el("lw24-support-messages");
    if (!box) return;
    var wrap = document.createElement("div");
    wrap.className = "lw24-support-ende";
    var t = document.createElement("div");
    t.className = "lw24-support-ende-t";
    t.textContent = "Dieses Gespräch wurde abgeschlossen.";
    var b = document.createElement("button");
    b.type = "button";
    b.className = "lw24-support-ende-neu";
    b.textContent = "Neue Frage stellen";
    b.addEventListener("click", function () {
      // Frische Sitzung: alter Fall bleibt im Postfach, der Kunde faengt sauber neu an.
      clearSession();
      state.geschlossen = false;
      state.aiReplyCount = 0; state.suggestShown = false;
      state.emailFormShown = false; state.dringendShown = false;
      statusAus();
      // Den Startbildschirm als ORIGINALKNOTEN retten und wieder einhaengen, nicht als Kopie:
      // der Klick-Listener haengt am Element selbst, eine Kopie waere still klick-tot. Genau diese
      // Falle hatte das Widget schon einmal, als die Vorschlaege per remove() entfernt wurden.
      var q = el("lw24-support-quick");
      if (box) {
        if (q && q.parentNode === box) box.removeChild(q);
        box.innerHTML = "";
        if (q) {
          // Aufklapp-Zustand und benutzte Eintraege zuruecksetzen, sonst startet das neue
          // Gespraech mit den Spuren des alten.
          auswahlLeeren();
          q.hidden = false;
          box.appendChild(q);
          toggleTopic(null);
        }
      }
      if (form) form.hidden = false;
      closePanel(); openPanel();
    });
    wrap.appendChild(t); wrap.appendChild(b);
    box.appendChild(wrap);
    scrollToEnd();
  }

  function showTyping(on) {
    var t = el("lw24-support-typing");
    if (t) t.hidden = !on;
    if (on) scrollToEnd();
  }

  // Runde 5 (27.07.2026): verstecken statt entfernen. Vorher rief sendMessage() ein q.remove() auf,
  // und zwar als ALLERERSTE Anweisung — mit drei Folgen: (1) der Klick-Listener haengt am Container
  // selbst, nach dem remove() waere jedes spaetere Wiedereinblenden klick-tot; (2) wer frei tippte
  // statt zu klicken, verlor alle Vorschlaege; (3) bei einem Netzwerkfehler blieb der Kunde ohne
  // Chips UND ohne gesendete Nachricht zurueck, weil das remove() vor dem fetch lief.
  function setQuickVisible(show) {
    var q = el("lw24-support-quick");
    if (q) q.hidden = !show;
    askBarSync();
    if (!show) { var t = el("lw24-support-title"); if (t) t.textContent = t.getAttribute("data-standard"); var bk = el("lw24-support-back"); if (bk) bk.hidden = true; }
    else { var o = openTopic(); var tt = el("lw24-support-title"); var c = o && q && q.querySelector('[data-cat="' + o + '"]'); var bk2 = el("lw24-support-back"); if (bk2) bk2.hidden = !o; if (tt && c) tt.textContent = (c.getAttribute("data-titel") || "").replace(/&amp;/g, "&"); }
  }

  // Zwei Ansichten im Startbildschirm (Stand 04.10.2026): "start" (vier Themenkarten) und "fragen"
  // (die Fragen EINES Themas). name === null zeigt den Start. Die Karte klappt nichts mehr auf, sie
  // fuehrt weiter: darunter springt nichts, und der Tipp auf eine Karte kann keine Frage treffen,
  // die unter dem Finger erscheint.
  //
  // Umgesetzt als Sichtbarkeits-Umschalter ueber statisches Markup: jeder Knopf bleibt derselbe
  // Knoten, der Klick-Listener haengt am Container (siehe "Neue Frage stellen").
  var ansichtSeit = 0;   // wann die Ansicht zuletzt gewechselt hat, siehe frageScharf
  function toggleTopic(name) {
    var q = el("lw24-support-quick");
    if (!q) return;
    Array.prototype.slice.call(q.querySelectorAll("[data-answers]")).forEach(function (box) {
      box.hidden = box.getAttribute("data-answers") !== name;
    });
    var start = q.querySelector('[data-view="start"]');
    var fragen = q.querySelector('[data-view="fragen"]');
    if (start) start.hidden = !!name;
    if (fragen) fragen.hidden = !name;
    auswahlLeeren();
    ansichtSeit = Date.now();
    var titel = el("lw24-support-title");
    var back = el("lw24-support-back");
    var karte = name && q.querySelector('[data-cat="' + name + '"]');
    if (titel) titel.textContent = (karte && karte.getAttribute("data-titel")) ? karte.getAttribute("data-titel").replace(/&amp;/g, "&") : titel.getAttribute("data-standard");
    if (back) back.hidden = !name;
    askBarSync();
    var box = el("lw24-support-messages");
    if (box && name) box.scrollTop = 0;
  }

  function openTopic() {
    var q = el("lw24-support-quick");
    var offen = q && q.querySelector("[data-answers]:not([hidden])");
    return offen ? offen.getAttribute("data-answers") : null;
  }

  // Auswahl: genau eine Frage, nie mehrere. Gesendet wird sie erst ueber #lw24-support-ask.
  function auswahlLeeren() {
    var q = el("lw24-support-quick");
    if (!q) return;
    Array.prototype.slice.call(q.querySelectorAll("[data-quick]")).forEach(function (b) {
      b.setAttribute("aria-pressed", "false");
    });
    askBarSync();
  }
  function auswahl() {
    var q = el("lw24-support-quick");
    return q ? q.querySelector('[data-quick][aria-pressed="true"]') : null;
  }
  // Die Leiste "Frage senden" steht nur in der Fragenansicht UND solange der Startbildschirm
  // ueberhaupt sichtbar ist. Ohne Auswahl ist der Knopf aus und sagt, was fehlt.
  function askBarSync() {
    var bar = el("lw24-support-ask-bar");
    var btn = el("lw24-support-ask");
    var q = el("lw24-support-quick");
    if (!bar || !btn) return;
    var sichtbar = !!(q && !q.hidden && openTopic());
    bar.hidden = !sichtbar;
    var wahl = auswahl();
    btn.disabled = !wahl;
    btn.textContent = wahl ? btn.getAttribute("data-an") : btn.getAttribute("data-aus");
  }
  // Ein Tipp gilt erst, wenn die Ansicht kurz steht. Ein Doppeltipp auf die Karte (oder der
  // nachgereichte Klick von iOS) trifft sonst die Frage, die an derselben Stelle erscheint.
  function frageScharf() { return Date.now() - ansichtSeit > 350; }

  // Die Sichtbarkeits-Regel steht bewusst an genau EINER Stelle und leitet sich aus dem
  // tatsaechlichen Verlauf ab, nicht daraus, ob eine Session existiert. Vorher genuegte eine
  // gespeicherte Session, damit die Vorschlaege beim Oeffnen sofort verschwanden — ein Besucher,
  // der vor Wochen einmal geschrieben hatte, sah sie nie wieder, selbst im voellig leeren Chat.
  //
  // Der Startbildschirm ist der LEERE Zustand, deshalb Schwelle 0 und nicht 1 oder 2: er ist das
  // erste Kind des Verlaufs, taeuchte er nach der ersten Antwort wieder auf, staende die
  // Begruessung ueber dem laufenden Gespraech — also ausserhalb des Sichtfelds, weil der Verlauf
  // dann bereits nach unten gescrollt ist.
  function refreshQuickVisibility() {
    var box = el("lw24-support-messages");
    if (!box) return;
    setQuickVisible(box.querySelectorAll(".lw24-support-msg.kunde").length === 0);
  }

  function saveSession() {
    try {
      if (state.session) localStorage.setItem(LS_SESSION, state.session);
      if (state.token) localStorage.setItem(LS_TOKEN, state.token);
    } catch (e) {}
    touchAktivitaet();
  }
  function clearSession() {
    state.session = null; state.token = null; state.knownCount = 0;
    try { localStorage.removeItem(LS_SESSION); localStorage.removeItem(LS_TOKEN); localStorage.removeItem(LS_LAST); localStorage.removeItem(LS_SEEN); localStorage.removeItem(LS_VORSCHAU_ZU); } catch (e) {}
    statusAus();
    hgReset();
  }

  // status 0 = Netzwerkfehler. Ohne dieses try/catch riss ein abgelehnter fetch das await poll() in
  // openPanel() mittendrin ab: der Verlauf war da schon geleert, aber Begruessung, Chips, Poll-Timer
  // und Fokus wurden nie mehr gesetzt — das Panel oeffnete komplett leer. Jeder Aufrufer behandelt
  // status 0 automatisch richtig, weil er ohnehin auf body.ok prueft.
  async function api(path, opts) {
    var r;
    try { r = await fetch(API + path, opts); }
    catch (e) { return { status: 0, body: null }; }
    var d = null; try { d = await r.json(); } catch (e) {}
    return { status: r.status, body: d };
  }

  async function ensureSession() {
    if (state.session && state.token) return true;
    var r = await api("/api/chat-start", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ page_url: location.href.slice(0, 300) })
    });
    if (r.status === 429) { addNote("Aus deinem Netzwerk wurden heute schon viele Chats gestartet. Schreib uns bitte an support@lampenwerk24.de, dort geht es sofort weiter."); return false; }
    if (!r.body || !r.body.ok) { addNote("Chat gerade nicht erreichbar. Bitte an support@lampenwerk24.de schreiben."); return false; }
    state.session = r.body.session_id; state.token = r.body.token; state.knownCount = 0;
    saveSession();
    return true;
  }

  /* knownCount ist der Stand des SERVERS, nicht unser eigener Zaehler.
     Bis zum 28.07.2026 wurde er lokal hochgezaehlt und trotzdem als Server-Index an chat-poll
     geschickt. Sobald zwischen zwei Aktualisierungen eine Nachricht auf dem Server dazukam — etwa
     weil Max im Postfach antwortete, waehrend der Kunde weitertippte — liefen beide Zahlen
     auseinander: Max' Nachricht wurde uebersprungen und die naechste Antwort dafuer ZWEIMAL
     gezeichnet. Danach blieb der Zaehler dauerhaft zu hoch, und jede weitere Antwort von Max
     verschwand still.
     Deshalb kommt der Stand jetzt immer vom Server (Feld "total"), und addMsg wirft doppelte
     msg_id ohnehin weg. */
  function renderIncoming(msgs, escalated, total) {
    var vonUns = (msgs || []).filter(function (m) { return m && m.von !== "kunde"; }).length;
    (msgs || []).forEach(function (m) { addMsg(m); });
    if (typeof total === "number") state.knownCount = total;
    else state.knownCount += (msgs || []).length;
    if (state.open) seenSetzen(state.knownCount);
    if (escalated) showEmailCapture();
    if (vonUns && document.hidden) titelMelden(vonUns);
  }

  /* ── Der Tab-Titel als Benachrichtigung ────────────────────────────────────
     Max am 14.08.2026: den "warmen Kunden wieder in den chat holen".

     Das hier ist der Weg, der OHNE jede Erlaubnis funktioniert und auf jedem
     Geraet ankommt - auch auf dem iPhone, wo eine echte Push-Meldung in einem
     normalen Safari-Tab gar nicht moeglich ist (dazu muesste der Kunde die
     Seite vorher zum Home-Bildschirm hinzufuegen). Kein Dialog, keine
     Abschreckung, keine Berechtigung: der Titel wechselt, solange der Tab im
     Hintergrund ist, und steht sofort wieder richtig da, sobald der Kunde
     zurueckkommt.

     Bewusst kein Ton: ein Chat-Widget, das ungefragt piept, wird abgeschaltet. */
  function titelMelden(anzahl) {
    if (state.titelOriginal === null) state.titelOriginal = document.title;
    state.ungelesen += anzahl;
    if (state.titelTimer) return;
    var an = false;
    state.titelTimer = setInterval(function () {
      an = !an;
      document.title = an
        ? "(" + state.ungelesen + ") Neue Antwort"
        : state.titelOriginal;
    }, 1400);
  }

  function titelZuruecksetzen() {
    if (state.titelTimer) { clearInterval(state.titelTimer); state.titelTimer = null; }
    if (state.titelOriginal !== null) { document.title = state.titelOriginal; }
    state.ungelesen = 0;
  }

  /* ── Ist der Kunde gerade da? ──────────────────────────────────────────────
     Max am 14.08.2026: "kann ja sein, dass der kunde mail bekommt und dann
     wieder im chat ist und wir direkt/zeitnah antworten und er noch im chat
     wartet, und man dann nicht 10 mails an den kunden sendet obwohl er aktiv
     am chatten ist."

     Genau diese Entscheidung kann der Worker heute nicht treffen: er sieht
     eine Antwort rausgehen und weiss nichts darueber, ob jemand davorsitzt.
     Die Antwort auf die Frage kennt nur der Browser des Kunden - also schickt
     er sie ab jetzt bei jedem Poll mit.

     praesent=1 heisst: Panel offen, Tab im Vordergrund UND innerhalb der
     letzten 90 Sekunden hat der Kunde etwas getan. Die dritte Bedingung ist
     die wichtige - ein offenes Panel in einem sichtbaren Tab heisst noch
     lange nicht, dass jemand hinsieht; ohne sie waere jeder, der den Chat
     offen liegen laesst, fuer immer "da" und bekaeme nie wieder eine Mail.

     ⚠️ DIE REGEL SELBST GEHOERT IN DEN WORKER, nicht hierher. Sie steht dort
     seit dem 14.08.2026 als chatMailRegel_: keine Mail, solange der letzte
     praesent=1 keine zwei Minuten her ist, und danach ein Mindestabstand von
     zehn Minuten je Fall, der wegfaellt, sobald der Kunde selbst wieder
     geschrieben hat. Das Theme liefert nur das Signal, entschieden wird
     serverseitig - alles andere waere manipulierbar. */
  var PRAESENZ_MS = 90000;

  function istPraesent() {
    return !!(state.open && !document.hidden && state.letzteAktion &&
              (Date.now() - state.letzteAktion) < PRAESENZ_MS);
  }

  /* ── WARUM NICHT JEDER POLL GESTEMPELT WIRD ────────────────────────────────
     praesent faehrt bei jedem Poll mit, aber der Worker DARF es nur selten
     festhalten: ein Poll alle 3 Sekunden waere ein KV-Schreibvorgang alle 3
     Sekunden je offenem Chatfenster, und genau daran ist die Idee im Worker
     bisher gescheitert (siehe den Kommentar an chatKundeWohlWeg_ dort).

     Also entscheidet der Browser, wann es sich lohnt: stempel=1 geht nur mit,
     wenn seit dem letzten Stempel 45 Sekunden vergangen sind ODER sich der
     Zustand geaendert hat (aus 1 wird 0 oder umgekehrt). Der Zustandswechsel
     ist der wichtigere Teil - er ist der Moment, in dem die Information neu
     ist, und ohne ihn haette der Worker bis zu 45 Sekunden lang einen
     veralteten Stand.

     Aus 20 Schreibvorgaengen pro Minute werden so hoechstens etwa zwei, und
     nur solange ueberhaupt jemand ein Chatfenster offen hat. */
  var STEMPEL_MS = 45000;

  function stempelFaellig(jetztPraesent) {
    if (state.stempelWert !== jetztPraesent) return true;
    return !state.stempelZeit || (Date.now() - state.stempelZeit) >= STEMPEL_MS;
  }

  /* ── Geschlossener Chat: rote Zahl am Knopf und Vorschau (P-69, Punkte 3 und 5) ─────────
     Bis zum 07.10.2026 hoerte das Widget bei geschlossenem Panel komplett auf zu fragen (poll()
     bricht bei !state.open ab, siehe dort). Eine Team-Antwort kam deshalb nur im Tab-Titel an,
     und das auch nur bei offenem Panel im Hintergrund-Tab.

     Jetzt fragt hgPoll() bei geschlossenem Chat alle 30 Sekunden nach, aber NUR mit gespeicherter
     Session, NUR im sichtbaren Tab und OHNE praesent-Stempel: ein geschlossener Chat darf dem
     Worker nie "Kunde ist da" melden, sonst unterdrueckt er die Antwort-Mail (chatMailRegel_).

     Gezaehlt wird gegen LS_SEEN, den Server-Stand, bis zu dem der Kunde zuletzt im offenen Chat
     alles gesehen hat. Die Zahl wird bei jedem Abruf NEU aus der Antwort gerechnet und nicht
     hochgezaehlt: zwei Tabs oder ein Seitenwechsel koennen sie so nie doppelt zaehlen. Sessions
     aus der Zeit vor diesem Update haben noch keinen Stand; sie bekommen beim ersten Abruf den
     aktuellen und zeigen keine Zahl (sonst stuende bei einem Altkunden "3 neu" fuer Antworten, die
     er laengst gelesen hat). */
  function seenLesen() {
    try { var v = parseInt(localStorage.getItem(LS_SEEN), 10); return isNaN(v) ? null : v; } catch (e) { return null; }
  }
  function seenSetzen(n) {
    try { localStorage.setItem(LS_SEEN, String(n)); } catch (e) {}
  }

  // Volltext (hoechstens 160 Zeichen): die Auslassung "…" setzt die Vorschau per CSS (text-overflow)
  // genau dort, wo die Zeile endet, bei 260px und bei 300px an verschiedenen Stellen.
  function kurztext(t) {
    t = String(t || "").replace(/\s+/g, " ").trim();
    return t.length > 160 ? t.slice(0, 160) : t;
  }

  function ungelesenAnzeigen(u) {
    var badge = el("lw24-support-badge");
    var bubble = el("lw24-support-bubble");
    var box = el("lw24-support-vorschau");
    var n = u && u.n ? u.n : 0;
    if (badge) {
      badge.hidden = !n;
      badge.textContent = n > 9 ? "9+" : String(n || "");
    }
    if (bubble) {
      bubble.setAttribute("aria-label", n
        ? "Support-Chat öffnen, " + (n === 1 ? "1 neue Antwort" : n + " neue Antworten") + " vom Team"
        : "Support-Chat öffnen");
    }
    if (!box) return;
    var zu = null;
    try { zu = localStorage.getItem(LS_VORSCHAU_ZU); } catch (e) {}
    if (!n || !u.id || String(u.id) === zu || state.open) { box.hidden = true; return; }
    var t = el("lw24-support-vorschau-text");
    t.querySelector(".lw24-support-vname").textContent = u.name ? u.name + " vom Team" : TEAM_FALLBACK;
    t.querySelector(".lw24-support-vmsg").textContent = u.text;
    box.setAttribute("data-id", String(u.id));
    box.hidden = false;
  }

  function ungelesenSpeichern(u) {
    try {
      if (u && u.n) localStorage.setItem(LS_UNGELESEN, JSON.stringify(u));
      else localStorage.removeItem(LS_UNGELESEN);
    } catch (e) {}
  }
  function ungelesenLesen() {
    try { var u = JSON.parse(localStorage.getItem(LS_UNGELESEN) || "null"); return u && u.n ? u : null; } catch (e) { return null; }
  }
  function ungelesenLoeschen() {
    ungelesenSpeichern(null);
    ungelesenAnzeigen(null);
  }

  async function hgPoll() {
    if (state.open || state.sending || hg.laeuft || hg.aus || document.hidden) return;
    if (!state.session || !state.token) return;
    hg.laeuft = true;
    try {
      var seen = seenLesen();
      var r = await api("/api/chat-poll?session=" + encodeURIComponent(state.session) +
        "&token=" + encodeURIComponent(state.token) + "&after=" + (seen === null ? 0 : seen) + "&praesent=0");
      if (state.open || !state.session) return;   // waehrend der Anfrage geoeffnet oder verworfen
      if (r.status === 404) { clearSession(); return; }
      if (!r.body || !r.body.ok) return;
      if (seen === null) { if (typeof r.body.total === "number") seenSetzen(r.body.total); return; }
      var team = (r.body.messages || []).filter(istTeamAntwort);
      /* Neuer Worker (c1f0704): letzte_team_nachricht = letzte NEUE Nachricht mit von "wir" und quelle
         "max", Quelle der Vorschau. Fehlt das Feld (alter Worker), wird sie aus messages abgeleitet.
         Die Anzahl kommt weiter aus messages; liefert nur das Feld etwas, zaehlt es als eine. */
      var feld = r.body.letzte_team_nachricht;
      if (feld && !istTeamAntwort(feld)) feld = null;   // selbe Regel wie im Verlauf, auch fuer das Feld
      var letzte = feld || team[team.length - 1];
      var u = letzte ? {
        n: team.length || 1,
        id: letzte.msg_id || ("t" + r.body.total),
        name: teamName(letzte),
        text: kurztext(letzte.text)
      } : null;
      ungelesenSpeichern(u);
      ungelesenAnzeigen(u);
      if (r.body.status === "resolved") hg.aus = true;
    } finally { hg.laeuft = false; }
  }

  function hgStart() {
    if (hg.timer) return;
    hg.timer = setInterval(hgPoll, HG_POLL_MS);
    setTimeout(hgPoll, 2500);
  }
  function hgReset() {
    hg.aus = false;
    ungelesenLoeschen();
  }

  async function poll() {
    /* ⚠️ HIER STAND "|| document.hidden" UND HAT DEN CHAT IM HINTERGRUND-TAB
       TAUB GEMACHT. Wer den Chat offen liess und den Tab wechselte, erfuhr von
       einer Antwort erst beim Zurueckkommen - und genau der Fall ist der, den
       Max zurueckholen will. Jetzt wird im Hintergrund weiter gehorcht, nur
       seltener (siehe startPoll), damit die neue Antwort den Tab-Titel
       erreichen kann. */
    if (!state.open || !state.session || !state.token) return;
    var praesent = istPraesent();
    var stempeln = stempelFaellig(praesent);
    if (stempeln) { state.stempelWert = praesent; state.stempelZeit = Date.now(); }
    var r = await api("/api/chat-poll?session=" + encodeURIComponent(state.session) +
      "&token=" + encodeURIComponent(state.token) + "&after=" + state.knownCount +
      "&praesent=" + (praesent ? "1" : "0") + (stempeln ? "&stempel=1" : ""));
    if (r.status === 404) { clearSession(); return; } // Session serverseitig geprüft/verwaist — nächste Nachricht startet neu
    if (r.body && r.body.ok) {
      if (r.body.messages && r.body.messages.length) renderIncoming(r.body.messages, r.body.escalated, r.body.total);
      else if (r.body.escalated) showEmailCapture();
      // Auch ohne neue Nachrichten den Serverstand uebernehmen: Sonst bleibt ein einmal
      // auseinandergelaufener Zaehler fuer immer falsch.
      else if (typeof r.body.total === "number") { state.knownCount = r.body.total; seenSetzen(state.knownCount); }
      if (r.body.status === "resolved") { chatGeschlossen(); stopPoll(); }
    }
  }

  /* Im Vordergrund alle 3 Sekunden, im Hintergrund alle 20. Der langsame Takt
     kostet drei Anfragen pro Minute und ist der Preis dafuer, dass eine Antwort
     den wartenden Kunden ueberhaupt erreichen kann, solange er auf einem
     anderen Tab ist. Bei geschlossenem Panel laeuft gar nichts, siehe poll(). */
  function pollTakt() { return document.hidden ? 20000 : POLL_MS; }

  function startPoll() {
    if (state.pollTimer) return;
    state.pollTakt = pollTakt();
    state.pollTimer = setInterval(poll, state.pollTakt);
  }
  function stopPoll() {
    if (state.pollTimer) { clearInterval(state.pollTimer); state.pollTimer = null; }
  }
  // Nach einem Sichtbarkeitswechsel muss der Takt neu gesetzt werden - ein
  // laufendes setInterval aendert sein Intervall nicht von selbst.
  function pollTaktPruefen() {
    if (!state.pollTimer || state.pollTakt === pollTakt()) return;
    stopPoll();
    startPoll();
  }

  // forceHuman: Kunde will explizit einen Menschen statt der KI (per Vorschlag-Button, siehe
  // maybeShowSuggestion) — chatSend() im Worker ueberspringt classifyAndMaybeAutoReply dann
  // komplett und eskaliert sofort. Der Autopilot bleibt der Standardweg fuer jede normal getippte
  // Nachricht (Max: "wir wollen vor allem KI-Antworten").
  // intent: Kennung der Schnellwahl ("lieferzeit", "versandkosten", ...). Der Worker beantwortet
  // diese Faelle regelbasiert und ohne KI-Aufruf — sofort statt nach mehreren Sekunden. Fehlt die
  // Kennung (frei getippte Nachricht), laeuft alles unveraendert ueber den bisherigen Weg.
  // Rueckgabe: true, wenn die Nachricht tatsaechlich rausgegangen ist. Der Aufrufer braucht das,
  // um einen Vorschlag wieder freizugeben, dessen Absenden gescheitert ist.
  async function sendMessage(text, forceHuman, intent, extra) {
    if (state.sending) return false;
    state.letzteAktion = Date.now();   // staerkstes Praesenzsignal ueberhaupt
    setQuickVisible(false); // nur fuer die Dauer des Sendens; danach entscheidet refreshQuickVisibility
    state.sending = true;
    var sendBtn = el("lw24-support-send");
    if (sendBtn) sendBtn.disabled = true;

    var okSession = await ensureSession();
    if (!okSession) { state.sending = false; if (sendBtn) sendBtn.disabled = false; refreshQuickVisibility(); return false; }

    addMsg({ von: "kunde", text: text, zeit: new Date().toISOString() });
    /* Der Zaehler wird hier bewusst NICHT erhoeht. Er ist der Stand des Servers, und die eigene
       Nachricht ist dort erst angekommen, wenn die Antwort zurueck ist. Frueher lief er genau
       dadurch voraus. Doppelt gezeichnet wird trotzdem nichts: addMsg verwirft bekannte msg_id. */
    showTyping(true);

    var hp = el("lw24-support-hp");
    var r = await api("/api/chat-send", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: state.session, token: state.token, message: text, website: hp ? hp.value : "", force_human: !!forceHuman, intent: intent || "", anlass: (extra && extra.anlass) || "", termin: (extra && extra.termin) || "" })
    });

    if (r.status === 404) {
      // Session serverseitig verschwunden (z.B. nach sehr langer Inaktivität) — einmalig neu starten.
      clearSession();
      var restarted = await ensureSession();
      if (restarted) {
        var retry = await api("/api/chat-send", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: state.session, token: state.token, message: text, force_human: !!forceHuman, intent: intent || "", anlass: (extra && extra.anlass) || "", termin: (extra && extra.termin) || "" })
        });
        if (retry.body && retry.body.ok) renderIncoming(retry.body.reply_messages, retry.body.escalated, retry.body.total);
      }
    } else if (r.body && r.body.ok) {
      /* NICHT einfach reply_messages zeichnen und den Zaehler auf total setzen.
         reply_messages enthaelt nur, was DIESER Aufruf angehaengt hat. Hat Max in der Zwischenzeit
         im Postfach geantwortet, wuerde seine Nachricht mit dem Sprung auf total als gesehen
         markiert und nie gezeichnet — genau der Fehler, den der Pruefaufbau am 28.07.2026
         nachgewiesen hat, und den die erste Fassung dieses Fixes noch nicht behoben hatte.
         Stattdessen sofort abgleichen: das holt Max' Nachricht UND die eigene Antwort, in der
         richtigen Reihenfolge. Kommt dabei nichts zurueck (Abgleich gescheitert), wird die Antwort
         ersatzweise direkt gezeichnet, damit der Kunde nie leer ausgeht. */
      var vorher = state.knownCount;
      await poll();
      if (state.knownCount === vorher) renderIncoming(r.body.reply_messages, r.body.escalated, r.body.total);
      if (r.body.dringend_moeglich) showDringend();
      if (r.body.abschluss_moeglich) showAbschluss();
      if (r.body.status === "resolved") chatGeschlossen();
    } else {
      addNote("Nachricht konnte nicht gesendet werden. Bitte erneut versuchen oder an support@lampenwerk24.de schreiben.");
    }

    showTyping(false);
    state.sending = false;
    if (sendBtn) sendBtn.disabled = false;
    refreshQuickVisibility();
    return true;
  }

  /* Kopplung zum Newsletter-Fenster (P-69 Folge): Klasse am <html> UND Ereignis.
     Das Fenster liest beides, ohne dass eine Ladefolge vorausgesetzt wird. */
  function chatZustandMelden(offen) {
    try {
      document.documentElement.classList.toggle("lw24-support-offen", !!offen);
      document.dispatchEvent(new CustomEvent("lw24:support-toggle", { detail: { offen: !!offen } }));
    } catch (e) { /* egal */ }
  }

  async function openPanel() {
    var panel = el("lw24-support-panel");
    var bubble = el("lw24-support-bubble");
    if (!panel) return;
    // VOR dem Verlauf-Rebuild unten: ist die Session verfallen, wird sie hier verworfen und der
    // Kunde bekommt den Startbildschirm statt eines wochenalten Gespraechs.
    sessionVerfallPruefen();
    panel.hidden = false;
    if (bubble) bubble.setAttribute("aria-expanded", "true");
    state.open = true;
    if (document.body) document.body.classList.add("lw24-support-offen");
    chatZustandMelden(true);
    // Oeffnen ist die deutlichste Kundenaktion ueberhaupt - ab hier gilt er als
    // anwesend, sonst waere praesent bis zur ersten Bewegung faelschlich 0.
    state.letzteAktion = Date.now();
    titelZuruecksetzen();
    scrollSperreSetzen();
    ungelesenLoeschen();   // rote Zahl und Vorschau weg, sobald der Chat aufgeht

    // Reihenfolge ist hier entscheidend und war bis Runde 5 falsch: die Begrüssung wurde ZUERST
    // eingefügt und vom Wipe weiter unten sofort wieder entfernt (sie trägt selbst die Klasse
    // .lw24-support-msg, der Kommentar behauptete das Gegenteil). Wiederkehrende Besucher sahen
    // deshalb weder Begrüssung noch Chips. Jetzt: erst aufräumen, dann laden, dann begrüssen.
    var box = el("lw24-support-messages");
    if (state.session && state.token) {
      // Frischer Verlauf-Rebuild aus dem Server statt Duplikate.
      state.knownCount = 0;
      state.lastMsgTime = null;
      state.aiReplyCount = 0;
      state.suggestShown = false;
      state.dringendShown = false;
      /* Auch die angehaengten Bloecke entfernen. Vorher blieben .lw24-support-ende,
      .lw24-support-abschluss und .lw24-support-dringend stehen — der Ende-Block landete dadurch
      beim Wiederoeffnen GANZ OBEN ueber dem neu geladenen Verlauf, das Eingabefeld blieb
      ausgeblendet, und der Kunde sah unten ein Gespraech ohne jede Eingabemoeglichkeit. Fuer ihn
      war der Chat kaputt. */
      state.geschlossen = false;
      state.abschlussShown = false;
      gezeichnet = {};
      offeneEigene = {};
      var f0 = el("lw24-support-form"); if (f0) f0.hidden = false;
      if (box) { Array.prototype.slice.call(box.querySelectorAll(".lw24-support-msg, .lw24-support-teamgrp, .lw24-support-time, .lw24-support-suggest, .lw24-support-ende, .lw24-support-abschluss, .lw24-support-dringend")).forEach(function (n) { n.remove(); }); }
      await poll();
    }
    // Kein addNote("Wie können wir helfen?") mehr: die Begrüssung ist seit Runde 5 Teil des
    // Startbildschirms im Markup. Genau dieser Aufruf war der Grund, warum sie sich frueher selbst
    // wieder loeschte — sie trug die Klasse .lw24-support-msg und lief in den Wipe oben.
    toggleTopic(null); // beim Oeffnen immer mit vier zugeklappten Themen beginnen
    refreshQuickVisibility();
    startPoll();
    /* ⚠️ KEIN Fokus auf dem Handy, 14.08.2026 (Max' iPhone-Screenshot).
       Das Eingabefeld beim Oeffnen zu fokussieren, klappt auf Touch-Geraeten sofort die
       Bildschirmtastatur auf. Die frisst rund die Haelfte des Panels — sichtbar blieben zwei
       der vier Themen, "Alle Fragen und Antworten ansehen" lag hinter der Tastatur. Der Kunde
       sah damit ausgerechnet das nicht, wofuer der Startbildschirm gebaut wurde.
       Auf dem Handy kommt die Tastatur jetzt erst, wenn der Kunde das Feld selbst antippt.
       Am Schreibtisch bleibt der Fokus: dort kostet er nichts und spart einen Klick. Geprueft
       wird der Zeiger, nicht die Breite — ein Touch-Tablet im Querformat ist breiter als 480px
       und bekommt trotzdem eine Bildschirmtastatur. */
    var zeigerGrob = false;
    try {
      zeigerGrob = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches === false;
    } catch (e) {
      zeigerGrob = "ontouchstart" in window;
    }
    if (!zeigerGrob) {
      var input = el("lw24-support-input");
      if (input) input.focus();
    }
  }

  function closePanel() {
    var panel = el("lw24-support-panel");
    var bubble = el("lw24-support-bubble");
    if (panel) panel.hidden = true;
    if (bubble) bubble.setAttribute("aria-expanded", "false");
    state.open = false;
    if (document.body) document.body.classList.remove("lw24-support-offen");
    chatZustandMelden(false);
    /* Letztes Lebenszeichen mit praesent=0, damit der Worker nicht erst durch
       AUSBLEIBENDE Polls auf "weg" schliessen muss. keepalive, weil der Tab
       gleich darauf geschlossen sein kann. Fehler sind egal: bleibt das Signal
       aus, greift serverseitig ohnehin die Zeitregel. */
    if (state.session && state.token) {
      // stempel=1: genau hier MUSS der Worker mitschreiben. Das Zumachen ist der
      // Moment, in dem die Mail-Kopie wieder erlaubt sein soll.
      state.stempelWert = false; state.stempelZeit = Date.now();
      try {
        fetch(API + "/api/chat-poll?session=" + encodeURIComponent(state.session) +
              "&token=" + encodeURIComponent(state.token) +
              "&after=" + state.knownCount + "&praesent=0&stempel=1",
              { keepalive: true }).catch(function () {});
      } catch (e) {}
    }
    titelZuruecksetzen();
    scrollSperreSetzen();
    stopPoll();
    if (state.session) seenSetzen(state.knownCount);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var bubble = el("lw24-support-bubble");
    var closeBtn = el("lw24-support-close");
    var form = el("lw24-support-form");
    var input = el("lw24-support-input");
    var quick = el("lw24-support-quick");

    if (bubble) bubble.addEventListener("click", function () { state.open ? closePanel() : openPanel(); });
    statusVerdrahten();
    // Vorschau: der Text oeffnet den Chat, das x schliesst nur die Vorschau (die Zahl bleibt).
    var vText = el("lw24-support-vorschau-text");
    var vX = el("lw24-support-vorschau-x");
    if (vText) vText.addEventListener("click", function () { if (!state.open) openPanel(); });
    /* Das x der Vorschau hing nur an "click" und hatte damit beide iOS-Wege, auf
       denen ein Klick verlorengeht (Kommentar am X des Panels weiter unten).
       Hier zaehlt touchend, und zwar mit preventDefault: das unterdrueckt den
       nachgeschobenen click, der sonst auf dem landet, was nach dem Ausblenden
       unter dem x liegt - die Vorschau steht mitten auf der Seite, darunter sind
       Links. click bleibt fuer Maus und Tastatur. Ohne Entprellung liefe es
       doppelt. */
    if (vX) {
      var zuletztV = 0;
      var vorschauZu = function (e) {
        var jetzt = Date.now();
        if (jetzt - zuletztV < 500) return;
        zuletztV = jetzt;
        if (e && e.preventDefault) e.preventDefault();
        var box = el("lw24-support-vorschau");
        try { localStorage.setItem(LS_VORSCHAU_ZU, box ? box.getAttribute("data-id") || "" : ""); } catch (e2) {}
        if (box) box.hidden = true;
      };
      vX.addEventListener("touchend", vorschauZu, { passive: false });
      vX.addEventListener("click", vorschauZu);
    }
    // Stand der letzten Seite sofort zeigen, der erste Abruf bestaetigt oder raeumt ihn ab.
    if (state.session && state.token) ungelesenAnzeigen(ungelesenLesen());
    hgStart();

    /* ⚠️ DAS ZUMACHEN HAENGT AN ZWEI EREIGNISSEN, NICHT NUR AN "click"
       (20.08.2026). Max vom iPhone: "Ich kann auf mobile nicht aufs x klicken -
       also wenn ich da mehrfach rauf klicke passiert nichts. Bin mal raus von
       der Seite - und wieder rein, dann ging es auch."

       Nachgestellt im Emulator schliesst der Knopf zuverlaessig, der Treffer
       landet auch genau auf ihm - der Fehler gehoert also iOS Safari, und dort
       gibt es zwei bekannte Wege, auf denen ein "click" verlorengeht:

       1. Das Panel macht beim Oeffnen den Seitenkoerper fest
          (body.lw24-support-scroll-halt, position:fixed). Faehrt in diesem
          Moment noch ein Schwung-Scroll aus, wertet Safari die naechsten
          Beruehrungen als Fortsetzung der Scrollgeste. touchend kommt an,
          click wird nie erzeugt.
       2. Mehrere schnelle Tipps hintereinander liest Safari als Doppeltipp
          zum Zoomen und verwirft beide. Genau das beschreibt "wenn ich
          mehrfach rauf klicke passiert nichts".

       pointerup entsteht in beiden Faellen trotzdem. Der click-Listener bleibt
       zusaetzlich stehen, denn Tastatur (Enter/Leertaste) erzeugt nur ihn.

       ⚠️ Die Entprellung ist Pflicht: normalerweise feuern BEIDE, und ohne sie
       liefe closePanel zweimal - das schickt auch das Abmelde-Signal zweimal
       an den Worker. 500ms sind grosszuegig; ein Kunde, der den Chat in einer
       halben Sekunde zu- und wieder aufmacht, existiert nicht.

       ⚠️ touch-action:manipulation in der CSS gehoert dazu (Fall 2 an der
       Wurzel). Wer eins von beidem entfernt, holt den halben Fehler zurueck. */
    if (closeBtn) {
      var zuletztZu = 0;
      var zumachen = function (e) {
        var jetzt = Date.now();
        if (jetzt - zuletztZu < 500) return;
        zuletztZu = jetzt;
        if (e && e.preventDefault) e.preventDefault();
        closePanel();
      };
      /* ⚠️ pointerdown WIRD ABGEFANGEN, UND ZWAR GEGEN EINEN GEISTERKLICK.
         Ohne diese Zeile schliesst pointerup das Panel, und der Browser
         schickt danach trotzdem noch sein click hinterher - nur liegt an der
         Stelle dann kein X mehr, sondern das, was darunter war. Ausgerechnet
         oben rechts ist das der Warenkorb der Kopfzeile. Aus "Chat zumachen"
         wuerde "Warenkorb auf".

         preventDefault auf pointerdown unterbindet die nachtraegliche
         Maus-Simulation samt click. Der click-Listener darunter bleibt fuer
         die Tastatur zustaendig - Enter und Leertaste erzeugen ihn ohne
         Zeigergeraet und laufen hier nie durch. */
      closeBtn.addEventListener("pointerdown", function (e) { if (e && e.preventDefault) e.preventDefault(); });
      closeBtn.addEventListener("pointerup", zumachen);
      closeBtn.addEventListener("click", zumachen);
    }
    /* Themenkarte fuehrt in die Fragenansicht, eine Frage wird nur AUSGEWAEHLT, gesendet wird mit
       "Frage senden". Alle drei Knoepfe sind echte <button>, der Listener haengt am Container. */
    if (quick) quick.addEventListener("click", function (e) {
      if (state.sending) return;
      var cat = e.target.closest("[data-cat]");
      if (cat) { toggleTopic(cat.getAttribute("data-cat")); return; }
      var item = e.target.closest("[data-quick]");
      if (!item || !frageScharf()) return;
      var schon = item.getAttribute("aria-pressed") === "true";
      auswahlLeeren();
      if (!schon) item.setAttribute("aria-pressed", "true");
      askBarSync();
    });
    var askBtn = el("lw24-support-ask");
    if (askBtn) askBtn.addEventListener("click", function () {
      if (state.sending) return;
      var item = auswahl();
      if (!item) return;
      var text = item.getAttribute("data-quick");
      var intent = item.getAttribute("data-intent");
      askBtn.disabled = true;
      // Ging die Nachricht NICHT raus, bleibt die Auswahl stehen und der Kunde kann es erneut
      // versuchen. Steht sie im Verlauf, blendet sendMessage den Startbildschirm selbst aus.
      sendMessage(text, false, intent).then(function (ok) {
        if (ok) auswahlLeeren(); else askBarSync();
      });
    });
    var backBtn = el("lw24-support-back");
    if (backBtn) backBtn.addEventListener("click", function () { toggleTopic(null); });
    if (form) form.addEventListener("submit", function (e) {
      e.preventDefault();
      var text = (input && input.value || "").trim();
      if (!text) return;
      if (input) { input.value = ""; composerAnpassen(input); }
      sendMessage(text);
    });
    if (input) {
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", { cancelable: true })); }
      });
      input.addEventListener("input", function () { composerAnpassen(input); });
    }
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) {
        titelZuruecksetzen();
        state.letzteAktion = Date.now();  // zurueck im Tab zaehlt als Aktion
        if (state.open) poll(); else hgPoll();
      }
      pollTaktPruefen();
    });

    /* Jede Kundenaktion IM Panel setzt den Praesenz-Stempel. Bewusst nur im
       Panel und nicht auf dem ganzen Dokument: wer auf der Produktseite
       weiterscrollt, waehrend der Chat offen daneben liegt, sitzt nicht im
       Chat - und genau der soll seine Mail bekommen. */
    var panel = el("lw24-support-panel");
    if (panel) {
      ["pointerdown", "keydown", "input", "scroll", "focusin"].forEach(function (ev) {
        panel.addEventListener(ev, function () { state.letzteAktion = Date.now(); }, true);
      });
    }
    // Geraet gedreht / Fenster schmaler-breiter gezogen, waehrend das Panel offen ist: die Sperre
    // gilt nur im Vollbild-Fall und muss dem Wechsel folgen (sonst bliebe z.B. nach Drehung ins
    // Querformat die Seite gesperrt, obwohl das Panel nur noch ein Popup ist).
    var mq = window.matchMedia(MOBILE_VOLLBILD_MQ);
    if (mq.addEventListener) mq.addEventListener("change", scrollSperreSetzen);
    else if (mq.addListener) mq.addListener(scrollSperreSetzen); // iOS < 14

    // Escape schliesst — bei zehn Chips ist der Tastatur-Weg aus dem Panel heraus sonst lang.
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && state.open) closePanel(); });

    /* ── DER RUECKWEG AUS DER ANTWORT-MAIL ────────────────────────────────────
       Die Mail, die der Worker bei einer spaeten Antwort verschickt, hat einen
       Knopf "Im Chat weiterschreiben". Der zeigt auf ?support=1 - und hier
       wird daraus wieder ein offenes Fenster mit dem alten Verlauf.

       Der Link traegt bewusst KEIN Sitzungs-Token (Begruendung steht im Worker
       an CHAT_MAIL_LINK: weitergeleitete Mails, Browserverlauf, Referrer). Auf
       demselben Geraet braucht es keins - Sitzung und Token liegen im
       localStorage und werden oben beim Start ohnehin gelesen. Auf einem
       fremden Geraet beginnt ein neues Gespraech, und die Antwort selbst steht
       ja schon in der Mail.

       replaceState raeumt den Parameter danach weg: sonst oeffnet sich der Chat
       bei jedem Zurueck-Knopf und bei jedem geteilten Link erneut. */
    try {
      if (/[?&]support=1(&|$)/.test(location.search)) {
        openPanel();
        if (history.replaceState) {
          var sauber = location.search.replace(/([?&])support=1(&|$)/, "$1").replace(/[?&]$/, "");
          history.replaceState(null, "", location.pathname + sauber + location.hash);
        }
      }
    } catch (e) {}
  });
})();